// Gom 6 việc hằng ngày của lễ tân thành MỘT nhóm menu đứng đầu — chỉ cho nhân
// sự quầy lễ tân (CEO chốt 27/09/2026, câu 2a).
//
// Vì sao cần (đánh giá giao diện lễ tân 27/09/2026): lễ tân thấy 20 mục trong 8
// nhóm; 6 việc làm mỗi ngày nằm rải ở 3 nhóm, "Lịch chụp" đứng thứ 11 — dưới cả
// "Khiếu nại", "Đơn in & bán thêm". Trên điện thoại phải cuộn menu mới thấy.
//
// Cùng nếp với `qc-quality-group.ts`: SẮP XẾP LÚC CHẠY chứ không sửa thẳng
// NAV_GROUPS, vì thứ tự 8 nhóm là CEO chốt 03/09/2026 cho MỌI vai. Hàm chỉ đổi
// thứ lễ tân nhìn thấy; vai khác nhận lại đúng mảng cũ. Không mục nào mất —
// mục chưa được gom vẫn ở nhóm cũ, chỉ dồn xuống dưới.
import type { NavGroup } from "./nav-items";

/**
 * Xếp theo NGÀY LÀM VIỆC ở quầy: nhìn lịch khách hôm nay → mở đơn → thu tiền →
 * két ca → khách ảnh thẻ vãng lai → nhận hàng in về.
 *
 * Mục nào người xem không được cấp quyền thì tự khuyết — hàm chỉ SẮP XẾP LẠI
 * những mục đã qua bộ lọc quyền, không mở thêm cửa nào.
 */
export const RECEPTION_DAILY_ITEM_IDS = [
  "schedule",
  "orders",
  "payment",
  "cash_drawer",
  "store_board",
  "print_ops",
] as const;

export const RECEPTION_DAILY_GROUP = { id: "reception_daily", label: "Việc hằng ngày" } as const;

export function groupDailyForReception(groups: NavGroup[], isReceptionDesk: boolean): NavGroup[] {
  if (!isReceptionDesk) return groups;
  return leadGroupOf(groups, RECEPTION_DAILY_ITEM_IDS, RECEPTION_DAILY_GROUP);
}

/**
 * Kéo các mục `ids` (đúng thứ tự đó) về MỘT nhóm `lead` đứng đầu menu. Dùng
 * chung cho mọi nhóm "Việc hằng ngày" (lễ tân ở trên, CSKH ở
 * `cskh-daily-group.ts`). Không mục nào trong `ids` có mặt thì trả lại đúng
 * mảng cũ.
 */
export function leadGroupOf(
  groups: NavGroup[],
  ids: readonly string[],
  lead: { id: string; label: string },
): NavGroup[] {
  const wanted = new Set<string>(ids);
  const picked = ids
    .map((id) => groups.flatMap((g) => g.items).find((i) => i.id === id))
    .filter((i) => i !== undefined);
  if (picked.length === 0) return groups;

  const rest = groups
    .map((g) => ({ ...g, items: g.items.filter((i) => !wanted.has(i.id)) }))
    .filter((g) => g.items.length > 0);

  return [{ ...lead, items: picked }, ...rest];
}
